import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDefibrillation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 14,
	viewBox: "0 0 13 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.5 1L2 6.5H11L5.5 12",
		stroke: "black",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 13.5V9L8.5 13.5H4Z",
		fill: "black"
	})]
});
export default SvgDefibrillation;
